/**
 * Created by ivan on 14.07.2026
 */

const RainbowComponentView = function (component, unitView) {
    this.component = component;
    this.unitView = unitView;

    this.dimmed = [];
    this.targetAnimations = [];
};

RainbowComponentView.prototype.highlightDrag = function () {
    this.unHighlightDrag();

    Merge2.current.field.iterateUnits((x, y, unit) => {
        if (unit === this.component.unit) {
            return;
        }

        const unitView = unit.onGetView();
        if (!unitView) {
            return;
        }

        if (this.component.isUpgradable(unit)) {
            this.createTargetAnimation(unitView);
            return;
        }

        if (!unit.findComponent(RainbowComponent) && !unit.isGrounded()) {
            unitView.setImageColor(RainbowComponentView.DIMMED_COLOR);
            this.dimmed.push(unit);
        }
    });
};

RainbowComponentView.prototype.createTargetAnimation = function (unitView) {
    const animation = new cleverapps.Spine(bundles.merge_animations.jsons.rainbow_target_json);
    animation.setAlignment({ align: "center" }, { align: "center" });
    animation.setAnimation(0, "animation", true);
    unitView.addChild(animation);

    this.targetAnimations.push(animation);
};

RainbowComponentView.prototype.unHighlightDrag = function () {
    const dimmed = this.dimmed;
    this.dimmed = [];

    dimmed.forEach((unit) => {
        const unitView = unit.onGetView();
        if (unitView) {
            unitView.restoreColor();
        }
    });

    const targetAnimations = this.targetAnimations;
    this.targetAnimations = [];

    targetAnimations.forEach((animation) => {
        animation.removeFromParent();
    });
};

RainbowComponentView.prototype.clearAnimations = function () {
    this.unHighlightDrag();
};

RainbowComponentView.DIMMED_COLOR = new cc.Color(150, 150, 150, 255);
